import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { FileText, X } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatFileSize } from '../utils/formatFileSize';

interface SourceFileChipProps {
  file: File;
  disabled?: boolean;
  onRemove: () => void;
}

export const SourceFileChip: React.FC<SourceFileChipProps> = ({ file, disabled, onRemove }) => {
  const { t, i18n } = useTranslation();

  return (
    <Box className="mb-3 flex min-w-0 flex-wrap items-center gap-2 rounded-lg border border-blue-200 bg-blue-50 px-3 py-2 dark:border-blue-900/60 dark:bg-blue-950/30">
      <FileText size={18} className="shrink-0 text-blue-600 dark:text-blue-400" />
      <Box className="min-w-0 flex-1">
        <Typography variant="body2" className="truncate font-medium text-gray-900 dark:text-white">
          {file.name}
        </Typography>
        <Typography variant="caption" className="text-gray-500 dark:text-slate-400">
          {formatFileSize(file.size, i18n.language)}
        </Typography>
      </Box>
      <Tooltip title={t('translate.source.removeFile')}>
        <span>
          <IconButton
            aria-label={t('translate.source.removeFile')}
            disabled={disabled}
            onClick={onRemove}
            size="small"
            className="text-gray-600 hover:bg-blue-100 hover:text-gray-900 disabled:text-gray-400 dark:text-slate-300 dark:hover:bg-slate-700 dark:hover:text-white dark:disabled:text-slate-600"
            sx={{ minWidth: 44, minHeight: 44 }}
          >
            <X size={18} />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};
